import * as Styled from "./style";

export const NewTag = () => {
  return <Styled.SpanNewTag>NEW</Styled.SpanNewTag>;
};
